<template>
    <v-row no gutters>
        <v-col>
            <v-list subheader :style="'height: 50vh; overflow: auto'">
                <v-list-subheader>
                    Sélectionnez l'utilisateur à conserver pour la fusion
                </v-list-subheader>
                <v-list-item
                    v-for="user in toMergeUsers"
                    :key="user.id"
                    class="mb-2"
                    @click="selectToKeepUser(user)"
                    :title="getUserDisplayName(user)"
                    density="compact"
                    rounded="xl"
                    lines="two"
                >
                    <!-- <v-list-item-title style="text-overflow: ellipsis; max-width: 600px">
                            {{ getUserDisplayName(user) }}
                        </v-list-item-title> -->
                    <!-- <v-list-item-subtitle>{{ user.siret }}</v-list-item-subtitle> -->
                    <!-- <div class="body-2">{{ company.address }} {{ company.city }}</div> -->
                    <template #append class="my-0">
                        <v-btn-icon
                            color="primary"
                            :icon="
                                user.id === toKeepUser.id
                                    ? '$radio_button_checked'
                                    : '$radio_button_unchecked'
                            "
                            v-if="user.candidate"
                        >
                        </v-btn-icon>
                    </template>
                </v-list-item>
                <v-list-item
                    class="oss-list-item my-1"
                    style="background: #fff"
                    v-if="toMergeUsersLoading"
                >
                    <v-skeleton-loader ref="skeleton" type="list-item-three-line" />
                </v-list-item>
            </v-list>
        </v-col>
    </v-row>
</template>
<script lang="ts">
import { Apollo } from "@/decorators";
import USERS_FROM_IDS from "../../graphql/user/UsersFromIds.gql";
import USERS_MERGE from "../../graphql/user/UsersMerge.gql";
import { getUserDisplayName } from "../../services/userServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {},
    emits: ["merge-done", "user-to-keep"],
})
export class MergeUsers extends Vue {
    @Prop({ default: [] }) userIdsToMerge: Array<any>;
    @Prop({ default: null }) actions: any;
    @Prop({ default: null }) companyId: string;

    toKeepUser = { id: "" };

    beforeMount() {
        debugger;
        if (this.actions?.action) {
            this.actions.action.function = this.usersMerge;
            // @ts-ignore
            this.actions.action.disabled = () => {
                return !this.toKeepUser?.id;
            };
            this.actions.action.hideValid = false;
            this.actions.action.title = () => {
                return "Valider la fusion";
            };
        }
    }

    get toMergeUsersLoading() {
        if (this.$apollo.queries.users) {
            return this.$apollo.queries.users.loading;
        }

        return false;
    }

    get filterToMergeTPCIds() {
        if (this.toMergeUsers) {
            const toKeepUserId = this.toKeepUser.id;
            const mergeUsers = this.toMergeUsers
                .map((mergeUser) => mergeUser.id)
                .filter((mergeUserId) => !(mergeUserId === toKeepUserId));
            return mergeUsers;
        }
        return [];
    }

    getUserDisplayName(user) {
        return getUserDisplayName(user);
    }

    @Apollo({
        query: USERS_FROM_IDS,
        variables() {
            return {
                userIds: this.userIdsToMerge.map((user) => user.id),
            };
        },
        // debounce: 500,
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    if (data.users) {
                        this.setToMergeUsers(data.users);
                    } else {
                        this.toMergeUsers = [];
                    }
                }
            }
        },
    })
    toMergeUsers: Array<any> = [];

    otherCompanyUserCount = 0;
    userWithSameCompanyAndWithMailCount = 0;

    setToMergeUsers(users) {
        this.otherCompanyUserCount = 0;
        this.userWithSameCompanyAndWithMailCount = 0;

        for (const user of users) {
            user.candidate = false;
            if (user.company.id !== this.companyId) {
                this.otherCompanyUserCount++;
            } else if (user.email) {
                this.userWithSameCompanyAndWithMailCount++;
                // user.candidate = true;
            }
        }

        if (!this.otherCompanyUserCount && !this.userWithSameCompanyAndWithMailCount) {
            for (const user of users) {
                user.candidate = true;
            }
        } else if (this.otherCompanyUserCount > 1 || this.userWithSameCompanyAndWithMailCount > 1) {
            for (const user of users) {
                if (user.company.id !== this.companyId || user.email) {
                    user.candidate = true;
                }
            }
        }

        this.toMergeUsers = users;
    }

    async usersMerge() {
        const toKeepTPCId = this.toKeepUser.id;
        const toMergeTPCIds = this.filterToMergeTPCIds;
        const companyId = this.$store.state.selected_company.id;

        // debugger
        const usersMerged = await this.$apollo.mutate({
            mutation: USERS_MERGE,
            variables: {
                toKeepUserId: toKeepTPCId,
                toMergeUsersIds: toMergeTPCIds,
                companyId: companyId,
            },
        });

        if (usersMerged) {
            this.$emit("merge-done");
        }
        // debugger
    }

    selectToKeepUser(user) {
        if (user.candidate) {
            this.$emit("user-to-keep", user);
            this.toKeepUser = user;
        }
    }
}

export default toNative(MergeUsers);
</script>
